// Fallback Accessibility Statement content for Essex Registrars appointments.
// Source of truth is the BookingLab app config key `accessibilityStatementPage.pageContent`
// (SUP-2540). This default renders the page before/if that config is absent.
//
// RPD-128: uses the shared council-agnostic default until Essex supplies its own
// audited statement. When it does, set the app config key.

export { GENERIC_ACCESSIBILITY_STATEMENT as ACCESSIBILITY_STATEMENT_FALLBACK } from '@bookinglab/ui/accessibility';
